import { setAwsConfigData } from "./redux/reducers/masterDataSlice";

export function awsConfig() {
  const awsBucket = {
    s3Bucket: "recruitment-software",
    s3BucketMainFolder: "production",
    s3BucketSubFolder: "files",
  };
  return awsBucket;
}
